import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import v from "./panelHeader.js";
import { useDualCalendarProps as y, useDualCalendar as P } from "./use-dual-calendar.js";
import { warnOnce as g } from "../../../_utils/naive/warn.js";
import b from "../../../_internal/focus-detector/src/FocusDetector.js";
import m, { XButton as M } from "../../../button/src/Button.js";
import { resolveSlotWithTypedProps as f, resolveSlot as l } from "../../../_utils/vue/resolve-slot.js";
import C from "../../../_internal/icons/FastBackward.js";
import $ from "../../../_internal/icons/Backward.js";
import k from "../../../_internal/icons/Forward.js";
import D from "../../../_internal/icons/FastForward.js";
import _ from "../../../input/src/Input.js";
import S from "../../../time-picker/src/TimePicker.js";
import { defineComponent as x, watchEffect as O, h as a } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const I = x({
  name: "DateTimeRangePanel",
  props: y,
  setup(o) {
    return process.env.NODE_ENV !== "production" && O(() => {
      var r;
      !((r = o.actions) === null || r === void 0) && r.includes("now") && g("date-picker", "The `now` action is not supported for n-date-picker of `datetimerange` type");
    }), P(o, "datetimerange");
  },
  render() {
    var o, r, p;
    const {
      mergedClsPrefix: e,
      mergedTheme: n,
      shortcuts: h,
      timePickerProps: c,
      onRender: u,
      datePickerSlots: i
    } = this;
    return u == null || u(), a("div", {
      ref: "selfRef",
      tabindex: 0,
      class: [`${e}-date-panel`, `${e}-date-panel--datetimerange`, !this.panel && `${e}-date-panel--shadow`, this.themeClass],
      onKeydown: this.handlePanelKeyDown,
      onFocus: this.handlePanelFocus
    }, a("div", {
      class: `${e}-date-panel-header`
    }, a(_, {
      value: this.startDateDisplayString,
      theme: n.peers.Input,
      themeOverrides: n.peerOverrides.Input,
      size: this.timePickerSize,
      stateful: !1,
      readonly: this.inputReadonly,
      class: `${e}-date-panel-date-input`,
      textDecoration: this.isStartValueInvalid ? "line-through" : "",
      placeholder: this.locale.selectDate,
      onBlur: this.handleStartDateInputBlur,
      onUpdateValue: this.handleStartDateInput
    }), a(S, Object.assign({
      placeholder: this.locale.selectTime,
      format: this.timePickerFormat,
      size: this.timePickerSize
    }, Array.isArray(c) ? c[0] : c, {
      value: this.startTimeValue,
      to: !1,
      showIcon: !1,
      disabled: this.isSelecting,
      theme: n.peers.TimePicker,
      themeOverrides: n.peerOverrides.TimePicker,
      stateful: !1,
      isHourDisabled: this.isStartHourDisabled,
      isMinuteDisabled: this.isStartMinuteDisabled,
      isSecondDisabled: this.isStartSecondDisabled,
      onUpdateValue: this.handleStartTimePickerChange
    })), a(_, {
      value: this.endDateInput,
      theme: n.peers.Input,
      themeOverrides: n.peerOverrides.Input,
      stateful: !1,
      size: this.timePickerSize,
      readonly: this.inputReadonly,
      class: `${e}-date-panel-date-input`,
      textDecoration: this.isEndValueInvalid ? "line-through" : "",
      placeholder: this.locale.selectDate,
      onBlur: this.handleEndDateInputBlur,
      onUpdateValue: this.handleEndDateInput
    }), a(S, Object.assign({
      placeholder: this.locale.selectTime,
      format: this.timePickerFormat,
      size: this.timePickerSize
    }, Array.isArray(c) ? c[1] : c, {
      disabled: this.isSelecting,
      showIcon: !1,
      theme: n.peers.TimePicker,
      themeOverrides: n.peerOverrides.TimePicker,
      to: !1,
      stateful: !1,
      value: this.endTimeValue,
      isHourDisabled: this.isEndHourDisabled,
      isMinuteDisabled: this.isEndMinuteDisabled,
      isSecondDisabled: this.isEndSecondDisabled,
      onUpdateValue: this.handleEndTimePickerChange
    }))), a("div", {
      ref: "startDatesElRef",
      class: `${e}-date-panel-calendar ${e}-date-panel-calendar--start`
    }, a("div", {
      class: `${e}-date-panel-month`
    }, a("div", {
      class: `${e}-date-panel-month__fast-prev`,
      onClick: this.startCalendarPrevYear
    }, l(i["prev-year"], () => [a(C, null)])), a("div", {
      class: `${e}-date-panel-month__prev`,
      onClick: this.startCalendarPrevMonth
    }, l(i["prev-month"], () => [a($, null)])), a(v, {
      monthYearSeparator: this.calendarHeaderMonthYearSeparator,
      monthBeforeYear: this.calendarMonthBeforeYear,
      value: this.startCalendarDateTime,
      onUpdateValue: this.onUpdateStartCalendarValue,
      mergedClsPrefix: e,
      calendarMonth: this.startCalendarMonth,
      calendarYear: this.startCalendarYear
    }), a("div", {
      class: `${e}-date-panel-month__next`,
      onClick: this.startCalendarNextMonth
    }, l(i["next-month"], () => [a(k, null)])), a("div", {
      class: `${e}-date-panel-month__fast-next`,
      onClick: this.startCalendarNextYear
    }, l(i["next-year"], () => [a(D, null)]))), a("div", {
      class: `${e}-date-panel-weekdays`
    }, this.weekdays.map((t) => a("div", {
      key: t,
      class: `${e}-date-panel-weekdays__day`
    }, t))), a("div", {
      class: `${e}-date-panel__divider`
    }), a("div", {
      class: `${e}-date-panel-dates`
    }, this.startDateArray.map((t, s) => {
      const d = this.mergedIsDateDisabled(t.ts);
      return a("div", {
        "data-n-date": !0,
        key: s,
        class: [`${e}-date-panel-date`, {
          [`${e}-date-panel-date--excluded`]: !t.inCurrentMonth,
          [`${e}-date-panel-date--current`]: t.isCurrentDate,
          [`${e}-date-panel-date--selected`]: t.selected,
          [`${e}-date-panel-date--covered`]: t.inSpan,
          [`${e}-date-panel-date--start`]: t.startOfSpan,
          [`${e}-date-panel-date--end`]: t.endOfSpan,
          [`${e}-date-panel-date--disabled`]: d
        }],
        onClick: d ? void 0 : () => {
          this.handleDateClick(t);
        },
        onMouseenter: d ? void 0 : () => {
          this.handleDateMouseEnter(t);
        }
      }, a("div", {
        class: `${e}-date-panel-date__trigger`
      }), t.dateObject.date, t.isCurrentDate ? a("div", {
        class: `${e}-date-panel-date__sup`
      }) : null);
    }))), a("div", {
      class: `${e}-date-panel__vertical-divider`
    }), a("div", {
      ref: "endDatesElRef",
      class: `${e}-date-panel-calendar ${e}-date-panel-calendar--end`
    }, a("div", {
      class: `${e}-date-panel-month`
    }, a("div", {
      class: `${e}-date-panel-month__fast-prev`,
      onClick: this.endCalendarPrevYear
    }, l(i["prev-year"], () => [a(C, null)])), a("div", {
      class: `${e}-date-panel-month__prev`,
      onClick: this.endCalendarPrevMonth
    }, l(i["prev-month"], () => [a($, null)])), a(v, {
      monthBeforeYear: this.calendarMonthBeforeYear,
      value: this.endCalendarDateTime,
      onUpdateValue: this.onUpdateEndCalendarValue,
      mergedClsPrefix: e,
      monthYearSeparator: this.calendarHeaderMonthYearSeparator,
      calendarMonth: this.endCalendarMonth,
      calendarYear: this.endCalendarYear
    }), a("div", {
      class: `${e}-date-panel-month__next`,
      onClick: this.endCalendarNextMonth
    }, l(i["next-month"], () => [a(k, null)])), a("div", {
      class: `${e}-date-panel-month__fast-next`,
      onClick: this.endCalendarNextYear
    }, l(i["next-year"], () => [a(D, null)]))), a("div", {
      class: `${e}-date-panel-weekdays`
    }, this.weekdays.map((t) => a("div", {
      key: t,
      class: `${e}-date-panel-weekdays__day`
    }, t))), a("div", {
      class: `${e}-date-panel__divider`
    }), a("div", {
      class: `${e}-date-panel-dates`
    }, this.endDateArray.map((t, s) => {
      const d = this.mergedIsDateDisabled(t.ts);
      return a("div", {
        "data-n-date": !0,
        key: s,
        class: [`${e}-date-panel-date`, {
          [`${e}-date-panel-date--excluded`]: !t.inCurrentMonth,
          [`${e}-date-panel-date--current`]: t.isCurrentDate,
          [`${e}-date-panel-date--selected`]: t.selected,
          [`${e}-date-panel-date--covered`]: t.inSpan,
          [`${e}-date-panel-date--start`]: t.startOfSpan,
          [`${e}-date-panel-date--end`]: t.endOfSpan,
          [`${e}-date-panel-date--disabled`]: d
        }],
        onClick: d ? void 0 : () => {
          this.handleDateClick(t);
        },
        onMouseenter: d ? void 0 : () => {
          this.handleDateMouseEnter(t);
        }
      }, a("div", {
        class: `${e}-date-panel-date__trigger`
      }), t.dateObject.date, t.isCurrentDate ? a("div", {
        class: `${e}-date-panel-date__sup`
      }) : null);
    }))), this.datePickerSlots.footer ? a("div", {
      class: `${e}-date-panel-footer`
    }, this.datePickerSlots.footer()) : null, !((o = this.actions) === null || o === void 0) && o.length || h ? a("div", {
      class: `${e}-date-panel-actions`
    }, a("div", {
      class: `${e}-date-panel-actions__prefix`
    }, h && Object.keys(h).map((t) => {
      const s = h[t];
      return Array.isArray(s) || typeof s == "function" ? a(M, {
        size: "tiny",
        onMouseenter: () => {
          this.handleRangeShortcutMouseenter(s);
        },
        onClick: () => {
          this.handleRangeShortcutClick(s);
        },
        onMouseleave: () => {
          this.handleShortcutMouseleave();
        }
      }, {
        default: () => t
      }) : null;
    })), a("div", {
      class: `${e}-date-panel-actions__suffix`
    }, !((r = this.actions) === null || r === void 0) && r.includes("clear") ? f(i.clear, {
      onClear: this.handleClearClick,
      text: this.locale.clear
    }, () => [a(m, {
      theme: n.peers.Button,
      themeOverrides: n.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleClearClick
    }, {
      default: () => this.locale.clear
    })]) : null, !((p = this.actions) === null || p === void 0) && p.includes("confirm") ? f(i.confirm, {
      onConfirm: this.handleConfirmClick,
      disabled: this.isRangeInvalid || this.isSelecting,
      text: this.locale.confirm
    }, () => [a(m, {
      theme: n.peers.Button,
      themeOverrides: n.peerOverrides.Button,
      size: "tiny",
      type: "primary",
      disabled: this.isRangeInvalid || this.isSelecting,
      onClick: this.handleConfirmClick
    }, {
      default: () => this.locale.confirm
    })]) : null)) : null, a(b, {
      onFocus: this.handleFocusDetectorFocus
    }));
  }
});
export {
  I as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/date-picker/src/panel/datetimerange.js
// module id = 1671
// module chunks = 67